import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";

import { useState, useEffect } from "react";
import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
} from "@mui/material";

import MultiPhoneInput, {
  isValidPhone,
  hasDuplicates,
} from "./MultiPhoneInput";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PhoneUpdate = ({
  page = "myaccount",
  open,
  onClose,
  values,
  setFieldValue,
  onSave,
  disableSave = false, // ✅ add
}) => {
  const [warningOpen, setWarningOpen] = useState(false);
  const [originalPhones, setOriginalPhones] = useState([]);
  const [shake, setShake] = useState(false);

  const phones = values.phone_numbers || [];

  useEffect(() => {
    if (open) {
      setOriginalPhones([...phones]);
    }
  }, [open]);

  const primary = phones[0] || "";

  const nonEmptyPhones = phones.filter((p) => p.trim() !== "");

  const primaryInvalid = !isValidPhone(primary);

  const anyInvalid = nonEmptyPhones.some((p) => !isValidPhone(p));

  const duplicateExists = hasDuplicates(nonEmptyPhones);

  const blockUpdate = primaryInvalid || anyInvalid || duplicateExists;

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        className: shake ? "dialog-shake" : "",
      }}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          setFieldValue("phone_numbers", originalPhones);
          onClose();
          return;
        }

        if (blockUpdate) {
          setWarningOpen(true);
          setShake(true);
          setTimeout(() => setShake(false), 400);
          return;
        }

        onClose();
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {page === "member" ? "Add Phone Numbers" : "Manage Phone Numbers"}

        <Tooltip title="Close modal" arrow>
          <IconButton
            edge="end"
            onClick={() => {
              setFieldValue("phone_numbers", originalPhones);
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      <DialogContent dividers>
        <MultiPhoneInput
          name="phone_numbers"
          values={values.phone_numbers}
          setFieldValue={setFieldValue}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            setFieldValue("phone_numbers", originalPhones); // restore old values
            onClose();
          }}
        >
          Cancel
        </Button>

        <Tooltip
          title={disableSave ? "No changes detected" : ""}
          arrow
          disableHoverListener={!disableSave}
        >
          <span>
            <Button
              onClick={() => {
                if (blockUpdate) {
                  setWarningOpen(true);
                  setShake(true);
                  setTimeout(() => setShake(false), 400);
                  return;
                }
                onSave();
              }}
              variant="contained"
              disabled={disableSave}
            >
              Update
            </Button>
          </span>
        </Tooltip>
      </DialogActions>
      <Snackbar
        open={warningOpen}
        autoHideDuration={3000}
        onClose={() => setWarningOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          position: "absolute",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <Alert severity="error" onClose={() => setWarningOpen(false)}>
          {primaryInvalid
            ? "Primary phone must be valid"
            : duplicateExists
              ? "Duplicate phone numbers are not allowed"
              : "All phone numbers must be valid"}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default PhoneUpdate;
